import { openCookieSettings } from "@/components/CookieConsent";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from "lucide-react";
const footerLinks = {
  company: [{
    name: "O nas",
    href: "/o-nas"
  }, {
    name: "Projekti",
    href: "/projekti"
  }, {
    name: "Reference",
    href: "/reference"
  }, {
    name: "Pogosta vprašanja",
    href: "/pogosta-vprasanja"
  }, {
    name: "Kontakt",
    href: "/kontakt"
  }, {
    name: "Kalkulator",
    href: "/kalkulator"
  }, {
    name: "Cenik",
    href: "/cenik"
  }],
  products: [{
    name: "Vgradne omare po meri",
    href: "/vgradne-omare-po-meri"
  }, {
    name: "Kuhinje",
    href: "/kuhinje"
  }, {
    name: "Omarni sistemi",
    href: "/produkti"
  }, {
    name: "Hoteli",
    href: "/hoteli"
  }, {
    name: "Poslovni prostori",
    href: "/poslovni-prostori"
  }, {
    name: "Tehnologija",
    href: "/tehnologija"
  }],
  architects: [{
    name: "Projektiranje",
    href: "/projektiranje"
  }, {
    name: "Idejne zasnove stanovanj",
    href: "/idejne-zasnove-stanovanj"
  }, {
    name: "Arhitektura",
    href: "/arhitektura"
  }, {
    name: "Tehnična dokumentacija",
    href: "/projektiranje#storitve"
  }, {
    name: "Sodelovanje",
    href: "/kontakt"
  }]
};
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-secondary border-t border-border">
      <div className="container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-bold mb-4">Interoform</h3>
            <p className="text-muted-foreground mb-6 max-w-md">Ustvarjamo ekskluzivno pohištvo in kuhinje po meri iz vrhunskih materialov. Izdelava in oblikovanje.</p>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-sm">
                <MapPin className="h-4 w-4 text-accent" />
                <span>Iška Loka 54, 1292 Ig</span>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <Phone className="h-4 w-4 text-accent" />
                <a href="tel:+38631704217" className="hover:text-accent transition-colors">
                  031 704 217
                </a>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <Mail className="h-4 w-4 text-accent" />
                <a href="mailto:info@interoform.com" className="hover:text-accent transition-colors">
                  info@interoform.com
                </a>
              </div>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold mb-4">Podjetje</h4>
            <ul className="space-y-2">
              {footerLinks.company.map(link => <li key={link.name}>
                  <Link to={link.href} className="text-sm text-muted-foreground hover:text-accent transition-colors">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Products Links */}
          <div>
            <h4 className="font-semibold mb-4">Produkti</h4>
            <ul className="space-y-2">
              {footerLinks.products.map(link => <li key={link.name}>
                  <Link to={link.href} className="text-sm text-muted-foreground hover:text-accent transition-colors">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Architects Links */}
          <div>
            <h4 className="font-semibold mb-4">B2B</h4>
            <ul className="space-y-2">
              {footerLinks.architects.map(link => <li key={link.name}>
                  <Link to={link.href} className="text-sm text-muted-foreground hover:text-accent transition-colors">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
            <div className="flex gap-4 mt-6">
              <a href="#" className="text-muted-foreground hover:text-accent transition-colors" aria-label="Facebook">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-accent transition-colors" aria-label="Instagram">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="text-muted-foreground hover:text-accent transition-colors" aria-label="LinkedIn">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">© {currentYear} Interoform. Vse pravice pridržane.</p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
            <Link to="/pravila-zasebnosti" className="hover:text-accent transition-colors">
              Pravila zasebnosti
            </Link>
            <button type="button" onClick={openCookieSettings} className="hover:text-accent transition-colors">
              Nastavitve piškotkov
            </button>
            <Link to="/splosni-pogoji" className="hover:text-accent transition-colors">
              Splošni pogoji
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}